import SelectAxis from "./Axis";

class SelectAxisX extends SelectAxis {}

export default SelectAxis;
